<template>
  <v-card elevation="0">
    <v-tabs
        v-model="tab"
        background-color="transparent"
        color="#80CBC4"
        grow
    >
        <v-tab
            v-for="item in tabitems"
            :key="item"
        >
            <v-icon>{{ item.icon }}</v-icon>&nbsp;{{ item.text }}
        </v-tab>
    </v-tabs>

    <v-tabs-items v-model="tab">
      <v-tab-item>
        <v-card elevation="0">
            <v-card-text>
                <Urgent />
            </v-card-text>
        </v-card>
      </v-tab-item>
      <v-tab-item>
        <v-card elevation="0">
            <v-card-text>
                <General />
            </v-card-text>
        </v-card>
      </v-tab-item>
    </v-tabs-items>
    <iframe name="hiddenFrame" hidden></iframe>
  </v-card>
</template>
<script>
import Urgent from "./UrgentAnnouncement.vue"
import General from "./GeneralAnnoucement.vue"
export default {
    components: {
        Urgent,
        General
    },
    data(){
        return {
            tab: null,
            tabitems: [
                {"text": 'Urgent', "icon": "mdi-timetable"},
                {"text": 'General', "icon": "mdi-table-cog"}
            ]
        }
    }
}
</script>